import { render, staticRenderFns } from "./africa_teacher_classlive.vue?vue&type=template&id=6d3d369e&scoped=true"
import script from "./africa_teacher_classlive.vue?vue&type=script&lang=js"
export * from "./africa_teacher_classlive.vue?vue&type=script&lang=js"
import style0 from "./africa_teacher_classlive.vue?vue&type=style&index=0&id=6d3d369e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3d369e",
  null
  
)

export default component.exports